function initCardAutoSlide() {
  if (window.innerWidth > 768) return;

  document.querySelectorAll('.card__media').forEach((card, cardIndex) => {
    const images = card.querySelectorAll('img');
    if (images.length < 2) return;

    let current = 0;

    // CSS Grid Ansatz - kein position absolute nötig
    card.style.display = 'grid';

    images.forEach((img, i) => {
      img.style.gridArea = '1 / 1';
      img.style.transition = 'opacity 0.6s ease';
      img.style.opacity = i === 0 ? '1' : '0';
      img.style.width = '100%';
      img.style.height = '100%';
      img.style.objectFit = 'cover';
    });

    setTimeout(() => {
      setInterval(() => {
        images[current].style.opacity = '0';
        current = (current + 1) % images.length;
        images[current].style.opacity = '1';
      }, 4000);
    }, cardIndex * 1000);
  });
}

document.addEventListener('DOMContentLoaded', initCardAutoSlide);
